import React from "react";
import { useMediaQuery } from "@mui/material";
import SoftBox from "../../components/SoftBox";
import PageHeader from "../../components/PageHeader";
// import BadGuySuggestions from "../../components/BadGuys/BadGuySuggestions";
import GameboardPageContainer from "../GameboardSettings/GameboardPageContainer";
import BadGuySelector from "./BadGuySelector";
import UnauthorizedPage from "../UnauthorizedPage";

const BadGuyPage = () => {
  const lgBreakpoint = useMediaQuery((theme) => theme.breakpoints.up("lg"));

  if (!lgBreakpoint) {
    return <UnauthorizedPage forAdmin={false} />;
  }

  return (
    <SoftBox>
      <PageHeader
        headerText="Bad Guy"
        subheaderText="Choose where you want to play the game."
        className="mb-8"
      />
      <SoftBox sx={{ margin: { mini: "1rem", sm: "1.5rem" } }}>
        <GameboardPageContainer
          title="Choose Your Bad Guy"
          caption=" Select a character or entity that represents the &quot;antagonist&quot; or challenge within Your gaming or performance tracking environment. Choose from a list of available bad guys,"
        >
          <BadGuySelector />
        </GameboardPageContainer>
      </SoftBox>
    </SoftBox>
  );
};

export default BadGuyPage;
